/** Converts CopilotKit message instances back into OpenAI-format messages for persistence. */
export function convertCopilotToOpenAI(copilotMessages) {
  return copilotMessages.map(function (msg) {
    if (msg.type === "TextMessage") {
      return {
        role: msg.role || "assistant",
        content: msg.content || ""
      };
    } else if (msg.type === "ActionExecutionMessage") {
      return {
        role: "assistant",
        content: msg.content || "",
        tool_calls: [{
          id: msg.id,
          type: "function",
          "function": {
            name: msg.name || "",
            arguments: JSON.stringify(msg.arguments || {})
          }
        }]
      };
    } else if (msg.type === "ResultMessage") {
      var content = "";
      if (typeof msg.result === "string") {
        content = msg.result;
      } else if (msg.result !== null && msg.result !== undefined) {
        content = JSON.stringify(msg.result);
      }
      return {
        role: "tool",
        tool_call_id: msg.actionExecutionId || "",
        content: content
      };
    } else {
      return {
        role: "assistant",
        content: msg.content || ""
      };
    }
  });
}